import { config } from '../Const';
import { executeFetchAsync } from '../Util';

const baseUrl = `${config.SERVER_URL}/api/v1/admin/fan-polls`;

export const listFanPolls = (search = '') => {
    const query = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
    return executeFetchAsync(`${baseUrl}${query}`, 'GET');
};

export const getFanPoll = (id) => executeFetchAsync(`${baseUrl}/${encodeURIComponent(id)}`, 'GET');

export const saveFanPoll = (request) => executeFetchAsync(
    baseUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    JSON.stringify(request)
);

export const publishFanPoll = (id) => executeFetchAsync(
    `${baseUrl}/${encodeURIComponent(id)}/publish`, 'PATCH'
);

export const unpublishFanPoll = (id) => executeFetchAsync(
    `${baseUrl}/${encodeURIComponent(id)}/unpublish`, 'PATCH'
);

export const getFanPollResults = (id) => executeFetchAsync(
    `${baseUrl}/${encodeURIComponent(id)}/results`, 'GET'
);

export const getFanPollCategories = () => executeFetchAsync(
    `${config.SERVER_URL}/api/v1/admin/entityData/mainCategories`, 'GET'
);

export const generateFanPollTags = (wikidataId) => executeFetchAsync(
    `${config.SERVER_URL}/api/v1/admin/entityData/tags?wikidataIdList=${encodeURIComponent(wikidataId)}`,
    'GET'
);

export const generateFanPollCopy = (request) => executeFetchAsync(
    `${config.SERVER_URL}/api/v1/admin/AI/generate-fan-poll`,
    'POST',
    { 'Content-Type': 'application/json' },
    JSON.stringify(request)
);

export const generateFanPollQuestionIdeas = (request) => executeFetchAsync(
    `${config.SERVER_URL}/api/v1/admin/AI/generate-fan-poll-question-ideas`,
    'POST',
    { 'Content-Type': 'application/json' },
    JSON.stringify(request)
);
